import { render, staticRenderFns } from "./RequestReset.vue?vue&type=template&id=d8e34152&"
import script from "./RequestReset.vue?vue&type=script&lang=js&"
export * from "./RequestReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports